class APIS {
	apis() {
		return {
			swichPaymentConfigurationAdd: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/add/client-payment-settings'
			},
			swichPaymentConfigurationFetch: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/client-payment-settings'
			},
			swichPaymentConfigurationUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/update/client-payment-settings'
			},
			swichPaymentConfigurationDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'delete',
				path: '/delete/client-payment-settings'
			},


		};
	}
}

export default new APIS();